import { render } from "./m-header.vue?vue&type=template&id=0d7b0b95"
import script from "./m-header.vue?vue&type=script&lang=js"
export * from "./m-header.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__